const state = {
  myInfo: {},
  dealerInfo: {},
  shopInfo: {},
  userInfo: {},
  shopScoreList: [],
  wechatBindList:[]
}
const	getters = {
  wechatBindList:state => {
    return state.wechatBindList;
  },
}
const	mutations = {
  setShopInfo(state, payload) {
    state.shopInfo = payload;
  },
  setMyInfo(state, payload) {
    state.myInfo = payload;
  },
  setDealerInfo(state, payload) {
    state.dealerInfo = payload;
  },
  setUser(state, payload) {
    state.userInfo = payload;
  },
  setShopScoreList(state, payload) {
    state.shopScoreList = payload;
  },
  getGetWecharList(state,payload){
    state.wechatBindList = payload
  }
}
const	actions = {
  reqShopScoreList( { commit }, params ) {
    return new Promise((r, j) => {
      fetch({
        url: "hcm/hcmReport/getPageByShop",
        method: "get",
        params: params,
        noFormat: true,
        responseType: "json"
      }).then((res) => {
        commit('setShopScoreList', res.data);
        r();
      }).catch(() => {
        j();
      })
    })
  },

  reqCustomField( { commit }, params ) {
    return new Promise((r, j) => {
      fetch({
        url: "hcm/hcmCustomModel/getBybmcidAndModule",
        method: "get",
        params: params,
        noFormat: true,
        responseType: "json"
      }).then((res) => {
        r(res.data);
      }).catch(() => {
        j();
      })
    })
  },

  // 获取客户用户信息
  reqServiceUser( { commit }, params ) {
    return new Promise((r, j) => {
      fetch({
        url: "hcm/userin/getByUserId",
        method: "get",
        params: params,
        noFormat: true,
      }).then((res) => {
        commit('setUser', res.data.data);
        r(res);
      }).catch(() => {
        j();
      })
    })
  },

  reqUser( { commit }, params ) {
    return new Promise((r, j) => {
      fetch({
        url: "hcm/userout/getUserById",
        method: "get",
        params: params,
        noFormat: true,
        responseType: "json"
      }).then((res) => {
        commit('setUser', res.data);
        r(res);
      }).catch(() => {
        j();
      })
    })
  },

  reqBindMobile( { commit }, params ) {
    return new Promise((r, j) => {
      fetch({
        url: "hcm/user/updatemobile",
        method: "post",
        params: params,
        noFormat: true,
        responseType: "json"
      }).then((res) => {
        r(res);
      }).catch(() => {
        j();
      })
    })
  },

  reqMyInfomation( { commit }, params ) {
    return new Promise((r, j) => {
      fetch({
        url: "hcm/userin/selectBmainOut",
        method: "get",
        params: params,
        noFormat: true,
        responseType: "json"
      }).then((res) => {
        commit('setMyInfo', res.data.data);
        r();
      }).catch(() => {
        j();
      })
    })
  },

  reqMoblieCode( { commit }, params ) {
    return new Promise((r, j) => {
      fetch({
        url: "hcm/login/sendSMS",
        method: "post",
        data: params,
        noFormat: true,
        responseType: "json"
      }).then((res) => {
        r(res);
      }).catch(() => {
        j();
      })
    })
  },

  reqValidateSMS( { commit }, params ) {
    return new Promise((r, j) => {
      fetch({
        url: "hcm/login/validateSMS",
        method: "get",
        params: params,
        noFormat: true,
        responseType: "json"
      }).then((res) => {
        r(res);
      }).catch(() => {
        j();
      })
    })
  },

  reqUpdatePassword( { commit }, params ) {
    return new Promise((r, j) => {
      fetch({
        url: "hcm/user/updatePassword",
        method: "post",
        data: params,
        noFormat: true,
        responseType: "json"
      }).then((res) => {
        r(res);
      }).catch(() => {
        j();
      })
    })
  },

  reqEditDealer( { commit }, params ) {
    return new Promise((r, j) => {
      fetch({
        url: "hcm/dealer/updateContact",
        method: "post",
        data: params,
        noFormat: true,
        responseType: "json"
      }).then((res) => {
        r(res);
      }).catch(() => {
        j();
      })
    })
  },

  reqEditCompany( { commit }, params ) {
    return new Promise((r, j) => {
      fetch({
        url: "hcm/cus/updateCustomer",
        method: "post",
        data: params,
        noFormat: true,
        responseType: "json"
      }).then((res) => {
        r(res);
      }).catch(() => {
        j();
      })
    })
  },

  reqUnbindWx( { commit }, params ) {
    return new Promise((r, j) => {
      fetch({
        url: "hcm/user/unbindWX",
        method: "post",
        data: params,
      }).then((res) => {
        r(res);
      }).catch(() => {
        j();
      })
    })
  },

  reqBindWx( { commit }, params ) {
    return new Promise((r, j) => {
      fetch({
        url: "hcm/wechat/getQRcode",
        method: "post",
        data: params,
      }).then((res) => {
        r(res);
      }).catch(() => {
        j();
      })
    })
  },

  reqShopInfo( { commit }, params ) {
    return new Promise((r, j) => {
      fetch({
        url: "hcm/hcmShop/getById",
        method: "get",
        params: params,
        noFormat: true,
        responseType: "json"
      }).then((res) => {
        commit('setShopInfo', res.data)
        r(res);
      }).catch(() => {
        j();
      })
    })
  },

  reqDealerInfo( { commit }, params ) {
    return new Promise((r, j) => {
      fetch({
        url: "hcm/dealer/findById",
        method: "get",
        params: params,
        noFormat: true,
        responseType: "json"
      }).then((res) => {
        commit('setDealerInfo', res.data)
        r(res);
      }).catch(() => {
        j();
      })
    })
  },

  reqServiceList( { commit }, params ) {
    return new Promise((r, j) => {
      fetch({
        url: "hcm/userin/getBmcListByKefuid",
        method: "get",
        params: params,
      }).then((res) => {
        // commit('setDealerInfo', res.data)
        r(res);
      }).catch(() => {
        j();
      })
    })
  },
  getWecharList({ commit }){
    //绑定微信列表
    return new Promise((r, j) => {
      fetch({
        url: "hcm/user/getWecharList",
        method: "get",
      }).then((res) => {
        commit('getGetWecharList',res.data)
      }).catch(() => {
        j();
      })
    })
  }

}

export default {
  state,
  getters,
  mutations,
  actions
}
